<form [formGroup]="skjema" data-testid="skjema">
  <div cdkDropList (cdkDropListDropped)="radFlyttet($event)" [cdkDropListSortPredicate]="flyttingTillatFn()">
    @for (kontroller of skjema.controls; track indeks; let indeks = $index; let erSisteRad = $last) {
      <div class="sakstype-rediger-rad" [class.slettet]="kontroller.value.slettet" cdkDrag [cdkDragDisabled]="erSisteRad" data-testid="rad">
        <div cdkDragHandle class="sortering-handler" [class.skjult]="erSisteRad">
          <mat-icon fontSet="ion-navicon" class="mat-icon--ionic-ikon" data-testid="dar-og-slipp"/>
        </div>

        <mat-form-field>
          <mat-label>
            @if (kontroller.value.ny) {
              {{ 'Ny sakstype' | translate }}
            } @else {
              {{ 'Navn' | translate }}
            }
          </mat-label>
          <input matInput [formControl]="kontroller.controls.tittel" name="tittel" data-testid="navn-felt">
          @if (kontroller.controls.tittel.hasError('duplikat')) {
            <mat-error>{{ 'Sakstypenavn må være unikt' | translate }}</mat-error>
          }
          @if (kontroller.controls.tittel.hasError('maxlength')) {
            <mat-error>
              {{ kontroller.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}
            </mat-error>
          }
        </mat-form-field>

        <div class="handlinger" [class.skjult]="erSisteRad">
          @if (!kontroller.value.slettet) {
            <!-- tooltip vises ikke på disabled knapp - legger derfor tooltip på omsluttende element -->
            <div [matTooltip]="kontroller.value.kanIkkeSlettes ? ('Sakstype kan ikke slettes fordi det finnes saker knyttet til sakstypen.' | translate) : ''">
              <button mat-icon-button type="button" (click)="slett(indeks)"
                      [disabled]="kontroller.value.kanIkkeSlettes"
                      aria-label="Slett sakstype"
                      data-testid="slett-knapp">
                <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
              </button>
            </div>
          } @else {
            <button mat-stroked-button type="button" (click)="angreSlett(indeks)">
              {{ 'Angre' | translate }}
            </button>
          }
        </div>

      </div>
    }
  </div>
  <kort-handlinger>
    <button mat-button type="button" (click)="avbryt()">{{ 'Avbryt' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" (click)="lagre()" [disabled]="lagrer() || skjema.invalid" data-testid="lagre-knapp">
      {{ 'Lagre' | translate }}
    </button>
  </kort-handlinger>
</form>
